import { cn } from "@/lib/utils";

interface IStepsProps {
  steps: string[];
  activeStepIndex: number;
  className?: string;
}

export function Steps({ steps, activeStepIndex, className }: IStepsProps) {
  const lastIndex = steps.length - 1;
  const basis = Math.round((1 / steps.length) * 100);

  return (
    <div className={cn("flex justify-center", className)}>
      {steps.map((step, i) => {
        const visited = i < activeStepIndex;
        const active = i == activeStepIndex;
        const first = i === 0;
        const last = i === lastIndex;
        return (
          <div
            key={i}
            style={{ flexBasis: (first || last ? basis / 2 : basis) + "%" }}
            className={cn(
              `flex flex-grow flex-col items-center justify-center gap-2.5 `
            )}
          >
            <div className="flex items-center justify-center w-full ">
              {!first && (
                <div
                  className={cn(
                    "h-[3px] bg-input flex flex-col items-center flex-grow",
                    (visited || active) && "bg-primary"
                  )}
                />
              )}
              <div
                className={cn(
                  "h-[30px] w-[30px] rounded-full bg-input text-sm flex justify-center  items-center",
                  (visited || active) && "bg-primary text-primary-foreground"
                )}
              >
                {i + 1}
              </div>
              {!last && (
                <div
                  className={cn(
                    "h-[3px] bg-input flex flex-col items-center flex-grow",
                    visited && "bg-primary"
                  )}
                />
              )}
            </div>
            <p
              className={cn(
                last && "self-end",
                first && "self-start",
                active && "text-primary font-bold"
              )}
            >
              {step}
            </p>
          </div>
        );
      })}
    </div>
  );
}
